<template>

  <div class="fixed w-full bottom-5 z-50 left-1/2 -translate-x-1/2 md:w-fit">
    <div class="container-1">
      <div class="relative py-2 px-3 md:py-3 md:px-6 text-ellie-black flex items-center justify-between gap-4 lg:gap-2 big-screen:gap-4 w-auto bg-white bg-opacity-70 backdrop-blur-md shadow-xl rounded-full overflow-hidden border border-black border-opacity-5">
        <a href="/" class="flex-shrink-0">
          <MainLogoChar class="w-full" :color="logoColor" :active-link="links[0]" />
        </a>

        <button @click="closeMenu" class="rounded-full flex items-center justify-center bg-ellie-blue text-white w-10 h-10 md:hidden">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-5">
            <path d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
          </svg>
        </button>
  
      </div>
    </div>
  </div>

  <div class="absolute w-full h-full bg-white bg-opacity-95 backdrop-blur-lg">
    <div class="container-1 py-5 md:py-[0.8vw]">
      <nav class="flex justify-between items-start">
        <div class="flex-grow masking-gradient-x w-1/4 md:hidden">
          <p id="scroll-text" class="text-xs lg:text-base w-full whitespace-nowrap">Singapore&nbsp;Creative&nbsp;Agency&nbsp;and&nbsp;Production&nbsp;House</p>
        </div>
      </nav>

      <div class="flex flex-col gap-2 mt-10">
        <NuxtLink
          @click.stop="closeMenu"
          v-for="item in links" :key="item.id"
          :to="item.href"
          data-aos="fade-up" :data-aos-delay="item.id * 100"
          class="w-fit text-2xl mx-auto px-8 py-3 font-medium uppercase inline-block rounded-full border border-black border-opacity-0 hover:border-opacity-100 transition-all duration-300"
        >
          {{ item.name }}
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script setup>
const emits = defineEmits(['onCloseMenu']);

const closeMenu = () => {
  emits('onCloseMenu');
};

const links = ref([
  {
    id: 0,
    href: '/',
    name: 'Home',
  },

  {
    id: 1,
    href: '/about',
    name: 'About',
  },

  {
    id: 2,
    href: '/works',
    name: 'Works',
  },

  {
    id: 3,
    href: '/our-services',
    name: 'Services',
  },

  {
    id: 4,
    href: '/journal',
    name: 'Journal',
  },

  {
    id: 5,
    href: '/get-in-touch',
    name: 'Get In Touch',
  },
]);
</script>
